import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getGroupsData = params =>
  axios.get(`${API_HOST}/groups`, { params, withCredentials: true });

export const getGroupDetailData = groupId =>
  axios.get(`${API_HOST}/groups/${groupId}`, { withCredentials: true });

export const editGruopData = (groupId, params) =>
  axios.put(`${API_HOST}/groups/${groupId}`, params, {
    withCredentials: true
  });

export const countEmailData = params =>
  axios.get(`${API_HOST}/groups`, { params, withCredentials: true });

export const downloadGroupData = params =>
  axios.get(`${API_HOST}/groups/download`, { params, withCredentials: true });

export const downloadGroupInfoData = params =>
  axios.get(`${API_HOST}/groups/info/download`, {
    params,
    withCredentials: true
  });

export const addGroupImageData = (groupId, params) =>
  axios.post(`${API_HOST}/groups/${groupId}/image`, params, {
    withCredentials: true
  });

export const getGroupAmountInfoData = params =>
  axios.get(`${API_HOST}/groups/top-page`, { params, withCredentials: true });

export const editGroupLoggedData = (groupId, params) =>
  axios.post(`${API_HOST}/groups/${groupId}/logged`, params, {
    withCredentials: true
  });

export const editGroupShopStatusData = (groupId, params) =>
  axios.post(`${API_HOST}/groups/${groupId}/shops/status`, params, {
    withCredentials: true
  });

export const updateGochiKidDonateFlagData = (groupId, params) =>
  axios.put(`${API_HOST}/gochi-kid/groups/can-has-donate/${groupId}`, params, {
    withCredentials: true
  });

export const editGroupGochiKidFlagShopData = (groupId, params) =>
  axios.put(
    `${API_HOST}/gochi-kid/groups/${groupId}/shops/change-use-setting`,
    params,
    {
      withCredentials: true
    }
  );

export const getGroupCampaignAmountInfoData = params =>
  axios.get(`${API_HOST}/groups/campaign/top-page`, {
    params,
    withCredentials: true
  });

export const updateGroupSettingGochiKidUnlimitData = (groupId, params) =>
  axios.post(`${API_HOST}/groups/gochi-kid-unlimit/${groupId}`, params, {
    withCredentials: true
  });

export const editGroupGochiKidMenuPriceShopData = (groupId, params) =>
  axios.put(
    `${API_HOST}/gochi-kid/groups/${groupId}/shops/change-menu-price-setting`,
    params,
    {
      withCredentials: true
    }
  );

export const getGroupGochiKidAmountInfoData = params =>
  axios.get(`${API_HOST}/groups/gochi-kid/top-page  `, {
    params,
    withCredentials: true
  });
